import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { DrugPlan } from '../../../models/drug-plan'
import { PlanList } from '../../../models/plan-list'
import { Notes } from '../../../models/notes'
import { EnrollmentElectionType } from '../../../models/enrollment-election-type'
import { Step4Model } from '../../../models/Step4Model'
import { DataEntryStep1 } from '../../../models/data-entry-step1'
import { BeneficiaryInfo } from '../../../models/enrollments'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { SubmitEnrollmentDataResponse } from '../../../models/submit-enrollment-data-response'
import { PortalGlobals } from '../../../../portalglobals'
import * as moment from 'moment'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'NEJESingleGroupStep4',
    templateUrl: 'single-group-step4.component.html'
})
export class NEJESingleGroupStep4Component implements OnInit {
    drugPlanModel = {} as DrugPlan
    notesModel = {} as Notes
    planList = [] as PlanList[]
    enrollmentElectionTypes: EnrollmentElectionType[] = [new EnrollmentElectionType()]
    paymentMethod: BeneficiaryInfo
    step4Model: Step4Model
    step1Model: DataEntryStep1
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    AccountName: string
    AccountType: string | null
    GenderType:string | null
    AgentName: string
    DataEntryAgentName: string
    hasError: boolean
    ErrorMessages: any[]
    userPofilename: string
    agentID: string
    appDate: string
    effDate: string
    dob: string
    medAdate: string
    medBDate: string
    sepEffDate: string
    poBoxOverride:string
    showSepEffDate: boolean
    public loading: boolean = false
    visibleFrom2025: boolean
    visibleFrom2026:boolean
    //EOBFlag: string
    //PaperlessOption: boolean
    baseTitle: string
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, private _portalGlobal: PortalGlobals, private titleService: Title) {
        this.step4Model = {} as Step4Model
        this.step4Model.notes = {} as Notes
        this.step4Model.prescriptionDrug = {} as DrugPlan
        this.paymentMethod = {} as BeneficiaryInfo
        this.ErrorMessages = [] as any[]
        //this.EOBFlag = ''
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {
        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle(this.baseTitle + ' - Confirm Group Enrollment')
        var User = localStorage.getItem('UserSessionContext')
        this._portalGlobal.currentUser = JSON.parse(User!)

        this.agentID = this._portalGlobal.currentUser.userProfileName
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()

        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollment === null || this.enrollment === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
        }

        if (this.enrollment.AGENTID === null || this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollment = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollment.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollment.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollment.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollment.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollment.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollment.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollment.ISSTCOB = this.enrollmentCacheData.ISSTCOB
                        this.enrollment.SINGLEGRPNAME = this.enrollmentCacheData.GroupPlanName
                        this.enrollment.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT

                        // this.enrollment.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings

                        this.LoadData()

                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
            }
        } else {
            this.LoadData()
        }
        // alert(this.paymentMethod.lastName)
    }

    LoadData(): void {
        this.appDate = this.enrollment.APPDT == undefined ? '' : moment(this.enrollment.APPDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.effDate = this.enrollment.EFFDT == undefined ? '' : moment(this.enrollment.EFFDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.dob = this.enrollment.APPDOB == undefined ? '' : moment(this.enrollment.APPDOB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.medAdate = this.enrollment.MEDA == undefined ? '' : moment(this.enrollment.MEDA, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.medBDate = this.enrollment.MEDB == undefined ? '' : moment(this.enrollment.MEDB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.sepEffDate = this.enrollment.SEPEFFDT == undefined ? '' : moment(this.enrollment.SEPEFFDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.showSepEffDate = this.enrollment.SEPEFFDT == undefined ? false : true
        this.userPofilename = this._portalGlobal.currentUser.userProfileName
        if (this._portalGlobal.selectedPlanYear > this._portalGlobal.Planyear2024) {
            this.visibleFrom2025 = true
        } else {
            this.visibleFrom2025 = false
        }
        this.visibleFrom2026 = this._portalGlobal.selectedPlanYear > this._portalGlobal.Planyear2025 ? true : false
        this.poBoxOverride = this.enrollment.POVERIND === '1' ? 'Yes' : 'No'
        if (this.enrollment !== undefined) {
            if (this.enrollment.EFTTYPE === 'S') {
                this.AccountType = 'Savings'
            } else if (this.enrollment.EFTTYPE === 'C') {
                this.AccountType = 'Checking'
            } else {
                this.AccountType = this.enrollment.EFTTYPE
            }
            if (this.enrollment.APPGEN === 'M') {
                this.GenderType = 'Male'
            } else if (this.enrollment.APPGEN === 'F') {
                this.GenderType = 'Female'
            }
            // get Agent Name in Agent ID & Data Entry ID
            this.AgentName = this.enrollment.AGENTID
            this.DataEntryAgentName = String(this.enrollment.ADMINID)

            //this.PaperlessOption = this.enrollment.PaperlessSettings
            /*
            if (this.enrollment.EOB !== undefined) {
                if (this.enrollment.EOB === '3') {
                    this.EOBFlag = 'Yes'
                } else {
                    this.EOBFlag = 'No'
                }
            }
            else {
                this.EOBFlag = ''
            }
            */
        }
    }
    formSubmit(): void {
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        //  this.loading = false
        //   this.router.navigate(['enrollment/neje/data-entry/Step5'])
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        this.updateDataServiceCall('/' + insCo + '/enrollment/neje/single-group/Step5')
    }

    goBack(): void {
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step3'])
    }

    updateDataServiceCall(route: string) {
        //this.router.navigate([route])
        this.enrollment.SUBMISSIONTYPECODE = 'COMPLETE'
        this.enrollment.STEPCODE = '4'
        this.loading = true
        this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe(
            (model: SubmitEnrollmentDataResponse) => {
                let response = model
                if (response !== undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = false

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        window.scrollTo(0, 0)
                    } else {
                        if (response.confirmationNumber !== undefined && response.confirmationNumber !== null && response.confirmationNumber !== '') {
                            this.enrollment.CONF = response.confirmationNumber
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                            this.loading = false
                            this.router.navigate([route])
                        } else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            window.scrollTo(0, 0)
                        }
                    }
                } else {
                    this.ErrorMessages.push('Error while submitting data, please try again.')
                    window.scrollTo(0, 0)
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }
}
